// extracted by mini-css-extract-plugin
export var container = "ChevronLink-module--container--LEviE";
export var chevron = "ChevronLink-module--chevron--xUu0G";
export var chevronLeft = "ChevronLink-module--chevron-left--x-dCj";
export var chevronRight = "ChevronLink-module--chevron-right--hERPs";